exports = module.exports = require("../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@font-face{font-family:Inconsolata;font-style:normal;font-display:swap;font-weight:400;src:local(\"Inconsolata Regular \"),local(\"Inconsolata-Regular\"),url(" + require("./files/inconsolata-latin-400.woff2") + ") format(\"woff2\"),url(" + require("./files/inconsolata-latin-400.woff") + ") format(\"woff\")}@font-face{font-family:Inconsolata;font-style:normal;font-display:swap;font-weight:700;src:local(\"Inconsolata Bold \"),local(\"Inconsolata-Bold\"),url(" + require("./files/inconsolata-latin-700.woff2") + ") format(\"woff2\"),url(" + require("./files/inconsolata-latin-700.woff") + ") format(\"woff\")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/typeface-inconsolata/index.css
// module id = ./node_modules/typeface-inconsolata/index.css
// module chunks = 17241999800008180000